import React from 'react'
import { featureData } from '../data/data'

export default function Feature() {
  return (
    <>
        <div className="row align-items-center g-4">
            {featureData.slice(0,4).map((item,index)=>{
                let Icon = item.icon
                return(
                    <div className="col-lg-3 col-md-6" key={index}>
                        <div className="card rounded p-4 py-5 bg-primary position-relative overflow-hidden border-0">
                            <Icon className="fea icon-md text-white z-1"/>
                            <div className="card-body p-0 mt-4">
                                <h5 className="text-white">{item.title}</h5>
                                <p className="para text-white-50 mb-0">{item.desc}</p>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div> 
    </>
  )
}
